/* eslint-disable */
import * as React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { TweenMax, Back } from 'gsap';

const styleSheet = {
  radioList: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '104px',
    // paddingLeft: '54px',
  },
  error: {
    borderColor: '#e60000 !important',
    transition: 'border 500ms',
  },
  label: {
    outline: 0,
    color: '#6373a4',
    fontSize: '18px',
    backgroundColor: 'transparent',
    padding: (props: any) => (props.width === 100 ? '25px 12px' : '5px 0'),
    marginRight: (props: any) => (props.width === 100 ? '20px' : 0),
    borderRadius: '7px',
    textAlign: 'left',
    '&:focus': {
      outline: 'dotted 1px gray',
    },
    '&:hover': {
      backgroundColor: (props: any) => props.width === 100 && '#f4f7fe',
    },
  },
  labelSelected: {
    backgroundColor: '#f4f7fe',
  },
  fullLabel: {
    color: '#6373a4',
    fontSize: '18px',
  },
  horizontal: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  vertical: {
    display: 'flex',
    flexDirection: 'column',
  },
  radioInput: {
    position: 'absolute',
    visibility: 'hidden',
    width: '18px',
    height: '18px',
    marginRight: '10px',
  },
  title: {
    paddingLeft: '9px',
    margin: 0,
    display: 'block',
    textAlign: 'left',
    marginBottom: '14px',
    textTransform: 'uppercase',
    color: '#223762',
    fontWeight: '800',
    fontFamily: 'CircularStd, sans-serif',
  },
  check: {
    boxSizing: 'border-box',
    top: '4px',
    marginRight: '10px',
    display: 'inline-block',
    width: '18px',
    height: '18px',
    border: 'solid 2px #b7c1e1',
    backgroundColor: '#fff',
    borderRadius: '100%',
    position: 'relative',
    transformOrigin: '50% 50%',
    transition: 'border 500ms',
  },
  inside: {
    transform: 'scale(0,0)',
    position: 'absolute',
    borderRadius: '100%',
    width: '8px',
    height: '8px',
    backgroundColor: '#085fe5',
    left: '3px',
    top: '3px',
    transformOrigin: '50% 50%',
  },
  '@media (max-width: 900px)': {
    title: {
      fontSize: '10px',
      marginLeft: 0,
    },
    radioList: {
      paddingLeft: '9px',
    },
  },
};

interface Props {
  width?: number;
  error?: boolean;
  checked: boolean;
  value?: string;
  field: any;
  classes: any;
  name?: string;
  defaultValue?: any;
  onChange?: (e: object) => void;
}

const radioButtons: React.FC<Props> = props => {
  const [selectedValue, setSelectedValue] = React.useState(
    props.defaultValue ? props.defaultValue : null
  );
  // Invoke useEffect without passing in selectedValue as dependency to invoke only on mount
  // https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
  React.useEffect(() => {
    if (selectedValue) {

      let selectedRadio = document.querySelectorAll(`#${selectedValue}`)[0];

      //find clicked radio elements //
      let checkbox = selectedRadio.querySelector('.check');
      let insideCircle = selectedRadio.querySelector('.inside');
      
      // animate inside circle in //
      TweenMax.to(insideCircle, 0.3, {
        scale: 1,
        ease: Back.easeOut,
        transformOrigin: '50% 50%',
      });

      // animate outer circle pulse //
      TweenMax.to(checkbox, 0.2, { scale: 1.3 });
      TweenMax.to(checkbox, 0.2, { scale: 1, delay: 0.2 });

      let response = {
        target: {
          value: selectedValue,
          fieldId: props.field.fieldId,
        },
      };
      
      props.onChange ? props.onChange(response) : null;
    }
  }, []);

  const handleChange = (
    node: any,
    parentNode: any,
    inputValue: any,
    value: string
  ) => {

    // let parent = event.target.parentNode;
    let allRadios = parentNode.querySelectorAll('.inside');

    //reset all radios //
    for (var i = 0; i < allRadios.length; i++) {
      TweenMax.set(allRadios[i], { scale: 0, transformOrigin: '50% 50%' });
    }

    //find clicked radio elements //
    let checkbox = node.querySelector('.check');
    let insideCircle = node.querySelector('.inside');

    // animate inside circle in //
    TweenMax.to(insideCircle, 0.3, {
      scale: 1,
      ease: Back.easeOut,
      transformOrigin: '50% 50%',
    });

    // animate outer circle pulse //
    TweenMax.to(checkbox, 0.2, { scale: 1.3 });
    TweenMax.to(checkbox, 0.2, { scale: 1, delay: 0.2 });

    setSelectedValue(inputValue);

    let response = {
      target: {
        value: value,
        fieldId: props.field.fieldId,
      },
    };
    props.onChange ? props.onChange(response) : null;
  };

  return (
    <div className={props.classes.radioList}>
      <p className={props.classes.title}>{props.field.label}</p>
      <div
        className={
          props.width === 100
            ? props.classes.horizontal
            : props.classes.vertical
        }
        data-name={props.name}
      >
        {props.field.list.map((item: any, index: number) => {
          return (
            <label
              className={props.classes.label}
              style={{
                backgroundColor:
                  selectedValue === item.value &&
                  props.width === 100 &&
                  '#f4f7fe',
              }}
              key={index}
              id={item.value}
              tabIndex={0}
              onKeyDown={e => {
                e.keyCode === 13 &&
                  handleChange(
                    document.getElementById(item.value),
                    document.getElementById(item.value).parentNode,
                    e.target.firstChild.getAttribute('value'),
                    item.value
                  );
              }}
            >
              <input
                className={props.classes.radioInput}
                type="radio"
                aria-label={props.name + '-' + item.value}
                value={item.value}
                checked={selectedValue === item.value}
                onChange={e =>
                  handleChange(
                    e.target.parentNode,
                    e.target.parentNode.parentNode,
                    e.target.value,
                    item.value
                  )
                }
              />
              <div
                className={classNames(props.classes.check + ' check', {
                  [props.classes.error]: props.error,
                })}
              >
                <div className={props.classes.inside + ' inside'} />
              </div>
              {item.label}
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(radioButtons);
